import axios from 'axios';

export const getS3Obj = async (getObjEndpoint) => {
  try {
    // const res = await axios.get(
    //   `http://localhost:3000${getObjEndpoint}`
    // );
    // if (res.data.Count) return res.data.Items; // Does response have a member named 'data'?
    axios.get(`http://localhost:3000${getObjEndpoint}`);
  } catch (error) {
    console.log(error);
  }
};
